<template>
  <div class="spinner-holder">
    <div
      class="lds-ripple"
      :style="`width:${this.size}px;height:${this.size}px;`"
    >
      <div></div>
      <div></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Spinner',
  props: {
    size: {
      type: Number,
      required: false,
      default: 64,
    },
  },
}
</script>

<style scoped>
.spinner-holder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.lds-ripple {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.lds-ripple div {
  position: absolute;
  border: 2px solid #fff;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
  top: 0;
  bottom: 0;
  margin: auto;
  left: 0;
  right: 0;
}
.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}
@keyframes lds-ripple {
  0% {
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    width: 90%;
    height: 90%;
    opacity: 0;
  }
}
</style>
